import { DataGridColumn } from 'RtUi/components/data/DataGrid/types';
import { FileLogStatsIndexResponse } from 'RtModels';
import { DefaultDataGridColumn } from 'RtUi/components/data/DataGrid/columns/DefaultDataGridColumn';
import { IntegerDataGridColumn } from 'RtUi/components/data/DataGrid/columns/IntegerDataGridColumn';
import { IdDataGridColumn } from 'RtUi/components/data/DataGrid/columns/IdDataGridColumn';
import { TimeStampDataGridColumn } from 'RtUi/components/data/DataGrid/columns/TimeStampDataGridColumn';
import { PrecisionDataGridColumn } from 'RtUi/components/data/DataGrid/columns/PrecisionDataGridColumn';
import { LabelDataGridColumn } from 'RtUi/components/data/DataGrid/columns/LabelDataGridColumn';

export const getFileLogStatsColumns = (): Array<
	DataGridColumn<FileLogStatsIndexResponse>
> => [
	IdDataGridColumn({
		accessorKey: 'fileStreamId',
		header: 'File Stream'
	}),
	LabelDataGridColumn({
		accessorKey: 'fileName',
		header: 'File Name'
	}),
	TimeStampDataGridColumn({
		accessorKey: 'minInviteTs',
		header: 'Min Invite'
	}),
	TimeStampDataGridColumn({
		accessorKey: 'maxInviteTs',
		header: 'Max Invite'
	}),
	IntegerDataGridColumn({
		accessorKey: 'atts',
		header: 'Atts'
	}),
	IntegerDataGridColumn({
		accessorKey: 'gflRecQty',
		header: 'Gfl Rec Qty'
	}),
	IntegerDataGridColumn({
		accessorKey: 'gflGoodRecQty',
		header: 'Gfl Good Rec Qty'
	}),
	IntegerDataGridColumn({
		accessorKey: 'inCons',
		header: 'In Conns'
	}),
	IntegerDataGridColumn({
		accessorKey: 'egCons',
		header: 'Eg Conns'
	}),
	IntegerDataGridColumn({
		accessorKey: 'hasCstRate',
		header: 'Has Cost Rate'
	}),
	IntegerDataGridColumn({
		accessorKey: 'hasRevRate',
		header: 'Has Rev Rate'
	}),
	IntegerDataGridColumn({
		accessorKey: 'noCstRateKey',
		header: 'No Cost Rate Key'
	}),
	IntegerDataGridColumn({
		accessorKey: 'noRevRateKey',
		header: 'No Rev Rate Key'
	}),
	IntegerDataGridColumn({
		accessorKey: 'defCstRateKey',
		header: 'Def Cost Rate Key'
	}),
	IntegerDataGridColumn({
		accessorKey: 'defRevRateKey',
		header: 'Def Rev Rate Key'
	}),
	PrecisionDataGridColumn({
		accessorKey: 'cstRateTtl',
		header: 'Cost Rate Tot'
	}),
	PrecisionDataGridColumn({
		accessorKey: 'revRateTtl',
		header: 'Rev Rate Tot'
	}),
	PrecisionDataGridColumn({
		accessorKey: 'cstTotalTtl',
		header: 'Cost Total Tot'
	}),
	PrecisionDataGridColumn({
		accessorKey: 'revTotalTtl',
		header: 'Rev Total Tot'
	}),
	PrecisionDataGridColumn({
		accessorKey: 'ttlCst',
		header: 'Tot Cost'
	}),
	PrecisionDataGridColumn({
		accessorKey: 'ttlRev',
		header: 'Tot Rev'
	}),
	PrecisionDataGridColumn({
		accessorKey: 'ttlMgn',
		header: 'Tot Margin'
	}),
	TimeStampDataGridColumn({
		accessorKey: 'createdTs',
		header: 'Created'
	}),
	TimeStampDataGridColumn({
		accessorKey: 'updatedTs',
		header: 'Updated'
	})
];
